(function(){
  'use strict';

  var TESSERACT_CDN='https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js';
  var MONTHS=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var scriptPromise=null,workerPromise=null;

  function loadScript(){
    if(window.Tesseract&&window.Tesseract.createWorker)return Promise.resolve(window.Tesseract);
    if(scriptPromise)return scriptPromise;
    scriptPromise=new Promise(function(resolve,reject){
      var existing=document.querySelector('script[data-lunova-tesseract="true"]');
      if(existing){
        var deadline=Date.now()+15000;
        var timer=setInterval(function(){
          if(window.Tesseract&&window.Tesseract.createWorker){clearInterval(timer);resolve(window.Tesseract)}
          else if(Date.now()>deadline){clearInterval(timer);reject(new Error('OCR_LIBRARY_TIMEOUT'))}
        },100);
        return;
      }
      var s=document.createElement('script');
      s.src=TESSERACT_CDN;s.async=true;s.crossOrigin='anonymous';s.dataset.lunovaTesseract='true';
      s.onload=function(){window.Tesseract&&window.Tesseract.createWorker?resolve(window.Tesseract):reject(new Error('OCR_LIBRARY_UNAVAILABLE'))};
      s.onerror=function(){reject(new Error('OCR_LIBRARY_LOAD_FAILED'))};
      document.head.appendChild(s);
    });
    return scriptPromise;
  }

  async function getWorker(){
    if(workerPromise)return workerPromise;
    workerPromise=(async function(){
      var T=await loadScript();
      var worker=await T.createWorker('eng');
      try{await worker.setParameters({preserve_interword_spaces:'1',tessedit_pageseg_mode:String(T.PSM&&T.PSM.SINGLE_BLOCK!=null?T.PSM.SINGLE_BLOCK:6)})}catch(_){}
      return worker;
    })();
    return workerPromise;
  }

  async function imageCanvas(file){
    var bitmap;
    try{bitmap=await createImageBitmap(file,{imageOrientation:'from-image'})}catch(_){bitmap=await createImageBitmap(file)}
    var maxSide=2200,w=bitmap.width,h=bitmap.height,scale=Math.min(1.75,maxSide/Math.max(w,h));
    if(scale<1)scale=Math.min(1,maxSide/Math.max(w,h));
    var canvas=document.createElement('canvas');
    canvas.width=Math.max(1,Math.round(w*scale));canvas.height=Math.max(1,Math.round(h*scale));
    var ctx=canvas.getContext('2d',{willReadFrequently:true});
    ctx.fillStyle='#fff';ctx.fillRect(0,0,canvas.width,canvas.height);
    ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';ctx.drawImage(bitmap,0,0,canvas.width,canvas.height);
    try{bitmap.close()}catch(_){}
    return canvas;
  }

  function parseTsv(tsv){
    var rows=[],lines=String(tsv||'').split(/\r?\n/);
    for(var i=1;i<lines.length;i++){
      var p=lines[i].split('\t');if(p.length<12||p[0]!=='5')continue;
      var text=p.slice(11).join('\t').trim(),conf=Number(p[10]);if(!text||!Number.isFinite(conf))continue;
      rows.push({page:Number(p[1]),block:Number(p[2]),par:Number(p[3]),line:Number(p[4]),left:Number(p[6]),top:Number(p[7]),width:Number(p[8]),height:Number(p[9]),conf:conf,text:text});
    }
    return rows;
  }

  function lineGroups(words){
    var map={},groups=[];
    words.forEach(function(w){
      var key=[w.page,w.block,w.par,w.line].join(':');
      if(!map[key])map[key]=[];map[key].push(w);
    });
    Object.keys(map).forEach(function(key){
      var ws=map[key].sort(function(a,b){return a.left-b.left}),top=Math.min.apply(null,ws.map(function(w){return w.top}));
      groups.push({key:key,top:top,words:ws,text:ws.map(function(w){return w.text}).join(' ')});
    });
    groups.sort(function(a,b){return a.top-b.top});
    return groups;
  }

  function monthToken(v){
    var s=String(v||'').toUpperCase().replace(/[^A-Z]/g,'');
    if(s.length<3)return null;s=s.slice(0,3);
    return MONTHS.indexOf(s)>=0?s:null;
  }
  function numberToken(v){
    var s=String(v||'').replace(/[,\s]/g,'').replace(/[Oo]/g,'0');
    if(!/^\d{1,4}(?:\.\d+)?$/.test(s))return null;
    var n=Number(s);return Number.isFinite(n)&&n>=0&&n<=15000?n:null;
  }
  function consecutive(ms){
    if(ms.length<12)return false;
    for(var i=1;i<ms.length;i++){
      var a=MONTHS.indexOf(ms[i-1]),b=MONTHS.indexOf(ms[i]);if(a<0||b!==((a+1)%12))return false;
    }
    return true;
  }
  function median(a){if(!a.length)return 0;var b=a.slice().sort(function(x,y){return x-y}),m=Math.floor(b.length/2);return b.length%2?b[m]:(b[m-1]+b[m])/2}
  function serviceZip(text){
    var m=String(text||'').match(/Service\s+Address[\s\S]{0,220}?\b(\d{5})(?:-\d{4})?\b/i);return m?m[1]:null;
  }

  function parseExplicitAnnualKwh(text,words,utilityHint){
    var raw=String(text||''),lines=raw.split(/\r?\n/),best=null;
    function utilityName(){
      if(/Ameren/i.test(raw))return 'Ameren Illinois';
      if(/CWLP|CITY\s+WATER[\s\S]{0,25}LIGHT[\s\S]{0,25}POWER/i.test(raw))return 'CWLP';
      return null;
    }
    for(var i=0;i<lines.length;i++){
      var line=String(lines[i]||'').replace(/\s+/g,' ').trim();
      if(!/(?:annual|12[\s-]*month|last\s+12|trailing\s+12)/i.test(line)||!/(?:kwh|kilowatt)/i.test(line))continue;
      if(/\$|amount\s+due|balance|charge/i.test(line))continue;
      var nums=line.match(/\b\d{1,3}(?:,\d{3})+\b|\b\d{4,6}\b/g)||[];
      for(var j=0;j<nums.length;j++){
        var value=Number(nums[j].replace(/,/g,''));
        if(!Number.isFinite(value)||value<1200||value>60000)continue;
        var score=0;
        if(/annual/i.test(line))score+=4;
        if(/12[\s-]*month|last\s+12|trailing\s+12/i.test(line))score+=4;
        if(/(?:usage|use|electricity|energy)/i.test(line))score+=3;
        if(/verified/i.test(line))score+=1;
        if(!best||score>best.score)best={score:score,value:value,line:line};
      }
    }
    if(!best||best.score<6)return null;
    var utility=utilityName();
    if(!utility)return null;
    return {status:'OK',code:'EXPLICIT_ANNUAL_KWH_TEXT_VERIFIED',utility_name:utility,service_zip:serviceZip(raw),
      monthly_usage_kwh:null,annual_usage_kwh:best.value,current_period_kwh:null,average_monthly_bill:null,
      amount_used_for_estimation:null,usage_confidence:'HIGH',verification_required:false,auto_use_allowed:true,
      usage_source:'UTILITY_STATEMENT_EXPLICIT_ANNUAL_KWH',page_count:1};
  }

  function visibleMonthlyCoverage(words){
    var monthWords=(words||[]).filter(function(w){return !!monthToken(w.text)&&w.conf>=20});
    var valueWords=(words||[]).filter(function(w){var n=numberToken(w.text);return n!=null&&n<=15000&&w.conf>=15});
    if(monthWords.length<12)return 0;
    var mh=Math.max(6,median(monthWords.map(function(w){return Math.max(1,w.height)}))),clusters=[];
    monthWords.slice().sort(function(a,b){return a.top-b.top}).forEach(function(w){
      var placed=null;
      for(var i=0;i<clusters.length;i++){if(Math.abs(w.top-clusters[i].top)<=Math.max(10,mh*1.8)){placed=clusters[i];break}}
      if(!placed){placed={top:w.top,words:[]};clusters.push(placed)}
      placed.words.push(w);placed.top=median(placed.words.map(function(x){return x.top}));
    });
    var best=0;
    clusters.forEach(function(cluster){
      var row=cluster.words.slice().sort(function(a,b){return a.left-b.left});
      if(row.length<12)return;
      var use=row.slice(-13),matched=0;
      use.forEach(function(mw){
        var mc=mw.left+mw.width/2,found=valueWords.some(function(vw){
          var vc=vw.left+vw.width/2,dy=mw.top-vw.top,dx=Math.abs(vc-mc);
          return dy>Math.max(2,mh*.35)&&dy<Math.max(80,mh*7.5)&&dx<Math.max(22,mh*2.5);
        });
        if(found)matched++;
      });
      best=Math.max(best,matched);
    });
    return best;
  }

  function spatialMonthlySeries(text,words,options){
    options=options||{};
    var maxMonthly=Number(options.maxMonthly||15000),maxAnnual=Number(options.maxAnnual||150000);
    var monthWords=(words||[]).filter(function(w){return !!monthToken(w.text)&&w.conf>=20});
    var valueWords=(words||[]).filter(function(w){var n=numberToken(w.text);return n!=null&&n<=maxMonthly&&w.conf>=15});
    if(monthWords.length<12||valueWords.length<12)return null;
    var heights=monthWords.map(function(w){return Math.max(1,w.height)}),mh=Math.max(6,median(heights));
    var sorted=monthWords.slice().sort(function(a,b){return a.top-b.top}),clusters=[];
    sorted.forEach(function(w){
      var placed=null;
      for(var i=0;i<clusters.length;i++){
        if(Math.abs(w.top-clusters[i].top)<=Math.max(10,mh*1.8)){placed=clusters[i];break}
      }
      if(!placed){placed={top:w.top,words:[]};clusters.push(placed)}
      placed.words.push(w);placed.top=median(placed.words.map(function(x){return x.top}));
    });
    var best=null;
    clusters.forEach(function(cluster){
      var row=cluster.words.slice().sort(function(a,b){return a.left-b.left});
      if(row.length<12)return;
      for(var s=0;s+12<=row.length;s++){
        var slice=row.slice(s,Math.min(row.length,s+13)),months=slice.map(function(w){return monthToken(w.text)});
        if(months.length===13&&!consecutive(months.slice(-12)))months=months.slice(-12),slice=slice.slice(-12);
        else if(months.length>=12&&!consecutive(months.slice(-12)))return;
        var chosenMonths=months.slice(-12),chosenWords=slice.slice(-12);
        if(!consecutive(chosenMonths))return;
        var values=[],confs=[],ok=true;
        chosenWords.forEach(function(mw){
          var mc=mw.left+mw.width/2,candidates=valueWords.filter(function(vw){
            var vc=vw.left+vw.width/2,dy=mw.top-vw.top,dx=Math.abs(vc-mc);
            return dy>Math.max(2,mh*.35)&&dy<Math.max(80,mh*7.5)&&dx<Math.max(22,mh*2.5);
          }).sort(function(a,b){
            var ac=a.left+a.width/2,bc=b.left+b.width/2;
            var as=Math.abs(ac-mc)+.12*Math.abs((mw.top-a.top)-mh*2.2)-.05*a.conf;
            var bs=Math.abs(bc-mc)+.12*Math.abs((mw.top-b.top)-mh*2.2)-.05*b.conf;
            return as-bs;
          });
          if(!candidates.length){ok=false;return}
          var v=numberToken(candidates[0].text);
          if(v==null||v>maxMonthly){ok=false;return}
          values.push(v);confs.push(candidates[0].conf,mw.conf);
        });
        if(!ok||values.length!==12)return;
        var annual=values.reduce(function(a,b){return a+b},0);
        if(annual<1200||annual>maxAnnual)return;
        var confidence=median(confs),score=(confidence>=70?5:confidence>=50?3:1)+values.length;
        if(!best||score>best.score)best={score:score,values:values,annual:annual,confidence:confidence,months:chosenMonths};
      }
    });
    return best;
  }

  function parseAmerenLines(text,words,options){
    options=options||{};
    var raw=String(text||''),utility=String(options.utility||'').toUpperCase();
    var utilityHint=/Ameren/i.test(raw)||utility.indexOf('AMEREN')>=0;
    var chartHint=/Electric\s+Usage\s+History/i.test(raw)||/Kilowatt\s+Hours|kWh/i.test(raw);
    if(!utilityHint||!chartHint)return null;
    var groups=lineGroups(words),best=null;
    for(var i=0;i<groups.length;i++){
      var monthWords=groups[i].words.filter(function(w){return !!monthToken(w.text)}),months=monthWords.map(function(w){return monthToken(w.text)});
      if(months.length<10)continue;
      for(var back=1;back<=4;back++){
        if(i-back<0)continue;
        var valueWords=groups[i-back].words.filter(function(w){return numberToken(w.text)!=null}),values=valueWords.map(function(w){return numberToken(w.text)});
        if(values.length<10)continue;
        var n=Math.min(months.length,values.length);if(n<12)continue;
        var ms=months.slice(months.length-n),vs=values.slice(values.length-n);
        if(n>13){ms=ms.slice(-13);vs=vs.slice(-13);n=13}
        var trailingMonths=ms.slice(-12),trailingValues=vs.slice(-12);
        if(trailingMonths.length!==12||trailingValues.length!==12||!consecutive(trailingMonths))continue;
        var nearby=groups.slice(Math.max(0,i-8),i+1).map(function(g){return g.text}).join(' ');
        var electric=/Electric/i.test(nearby)&&/(Usage|Kilowatt|kWh)/i.test(nearby),gas=/Gas\s+Usage/i.test(nearby);
        if(!electric&&utility.indexOf('AMEREN')<0)continue;
        if(gas&&!/Electric[\s\S]*Gas/i.test(nearby))continue;
        var annual=trailingValues.reduce(function(a,b){return a+b},0);if(annual<1200||annual>150000)continue;
        var confs=monthWords.concat(valueWords).map(function(w){return w.conf}).filter(Number.isFinite),confidence=median(confs);
        var score=(months.length>=13?3:2)+(values.length>=13?3:2)+(confidence>=70?3:confidence>=50?2:1)+(electric?3:1);
        if(!best||score>best.score)best={score:score,values:trailingValues,annual:annual,confidence:confidence};
      }
    }
    if(!best){
      var spatial=spatialMonthlySeries(raw,words,{maxMonthly:15000,maxAnnual:150000});
      if(spatial)best={score:spatial.score+4,values:spatial.values,annual:spatial.annual,confidence:spatial.confidence,source:'AMEREN_SPATIAL_HISTORY_FALLBACK'};
    }
    if(!best){
      var flat=raw.replace(/\s+/g,' '),pairs=[],m;
      var re=/\b(\d{1,5})\s+(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\b/gi;
      while((m=re.exec(flat))!==null){
        var v=Number(m[1]);if(Number.isFinite(v)&&v>=0&&v<=15000)pairs.push({value:v,month:m[2].toUpperCase()});
      }
      for(var p=Math.max(0,pairs.length-16);p+12<=pairs.length;p++){
        var pairSlice=pairs.slice(p,p+12),pms=pairSlice.map(function(x){return x.month}),pvs=pairSlice.map(function(x){return x.value});
        if(!consecutive(pms))continue;var pann=pvs.reduce(function(a,b){return a+b},0);
        if(pann<1200||pann>150000)continue;
        best={score:7,values:pvs,annual:pann,confidence:65,source:'AMEREN_PAIR_HISTORY_FALLBACK'};break;
      }
    }
    if(!best){
      var coverage=visibleMonthlyCoverage(words);
      if(coverage>=5&&coverage<12){
        return {status:'NEEDS_MANUAL_USAGE',code:'AMEREN_INCOMPLETE_USAGE_HISTORY',utility_name:'Ameren Illinois',service_zip:serviceZip(raw),monthly_usage_kwh:null,annual_usage_kwh:null,current_period_kwh:null,average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:'LOW',verification_required:true,auto_use_allowed:false,usage_source:'INCOMPLETE_VISIBLE_MONTHLY_HISTORY',page_count:1};
      }
      return null;
    }
    var code=best.source==='AMEREN_SPATIAL_HISTORY_FALLBACK'?'AMEREN_IMAGE_OCR_SPATIAL_HISTORY_VERIFIED':(best.source==='AMEREN_PAIR_HISTORY_FALLBACK'?'AMEREN_IMAGE_OCR_PAIR_HISTORY_VERIFIED':'AMEREN_IMAGE_OCR_HISTORY_VERIFIED');
    return {status:'OK',code:code,utility_name:'Ameren Illinois',service_zip:serviceZip(raw),monthly_usage_kwh:best.values,annual_usage_kwh:best.annual,current_period_kwh:best.values[11],average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:best.confidence>=65?'HIGH':'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'AMEREN_IMAGE_OCR_12_MONTH_HISTORY',page_count:1};
  }

  function inferComEdMonthColumns(group){
    var words=[];
    (group&&group.words||[]).forEach(function(w){
      var raw=String(w.text||'').toUpperCase(),matches=raw.match(/JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC/g)||[];
      if(!matches.length)return;
      if(matches.length===1){words.push(w);return}
      var partWidth=Math.max(1,Number(w.width||1)/matches.length);
      matches.forEach(function(mon,i){
        words.push({page:w.page,block:w.block,par:w.par,line:w.line,left:Number(w.left||0)+partWidth*i,top:w.top,width:partWidth,height:w.height,conf:w.conf,text:mon});
      });
    });
    words=words.sort(function(a,b){return a.left-b.left});
    if(words.length<12)return null;
    var best=null;
    for(var start=0;start+12<=words.length;start++){
      var slice=words.slice(start,Math.min(words.length,start+13));
      if(slice.length<12)continue;
      var centers=slice.map(function(w){return w.left+w.width/2}),gaps=[];
      for(var g=1;g<centers.length;g++)gaps.push(centers[g]-centers[g-1]);
      var gapMedian=median(gaps);if(gapMedian<12)return;
      var regular=gaps.filter(function(x){return Math.abs(x-gapMedian)<=Math.max(9,gapMedian*.38)}).length;
      if(regular<Math.max(8,gaps.length-3))continue;
      for(var startMonth=0;startMonth<12;startMonth++){
        var score=0,exact=0;
        for(var i=0;i<slice.length;i++){
          var token=monthToken(slice[i].text),expected=MONTHS[(startMonth+i)%12];
          if(token===expected){score+=3;exact++}
          else if(token)score-=2;
        }
        if(exact<5)continue;
        score+=regular;
        if(!best||score>best.score)best={score:score,words:slice,months:slice.map(function(_,i){return MONTHS[(startMonth+i)%12]})};
      }
    }
    return best;
  }
  function splitMergedDigitsForCount(text,count){
    var runs=String(text||'').match(/\d+/g)||[];
    function valid(v){var n=Number(v);return /^\d{2,5}$/.test(v)&&Number.isFinite(n)&&n>=50&&n<=15000}
    if(runs.length===count&&runs.every(valid))return runs.map(Number);
    var digits=runs.join('');if(!digits||count<1)return null,best=null;
    function rec(pos,left,parts,score){
      if(left===0){
        if(pos===digits.length&&(!best||score<best.score))best={score:score,parts:parts.slice()};
        return;
      }
      var remain=digits.length-pos;if(remain<2*left||remain>5*left)return;
      for(var len=2;len<=5;len++){
        if(pos+len>digits.length)break;
        var s=digits.slice(pos,pos+len);if(s.length>1&&s[0]==='0')continue;
        var n=Number(s);if(!Number.isFinite(n)||n<50||n>15000)continue;
        var penalty=len===4?0:len===3?.55:len===2?2.5:3;
        if(n<100)penalty+=2;if(n>5000)penalty+=2;
        parts.push(n);rec(pos+len,left-1,parts,score+penalty);parts.pop();
      }
    }
    rec(0,count,[],0);return best?best.parts:null;
  }
  function parseComEdMergedBarHistory(words){
    var groups=lineGroups(words),best=null;
    for(var i=0;i<groups.length;i++){
      var cols=inferComEdMonthColumns(groups[i]);if(!cols)continue;
      var monthWords=cols.words,monthCenters=monthWords.map(function(w){return w.left+w.width/2});
      for(var back=1;back<=6;back++){
        if(i-back<0)continue;
        var vg=groups[i-back],dy=groups[i].top-vg.top;
        if(dy<8||dy>150)continue;
        var assigned=new Array(monthWords.length).fill(null),confs=[];
        (vg.words||[]).forEach(function(w){
          var raw=String(w.text||''),runs=raw.match(/\d+/g)||[];if(!runs.length)return;
          var left=w.left-4,right=w.left+w.width+4,idx=[];
          for(var k=0;k<monthCenters.length;k++)if(monthCenters[k]>=left&&monthCenters[k]<=right)idx.push(k);
          if(!idx.length){
            var wc=w.left+w.width/2,nearest=0,dist=Infinity;
            monthCenters.forEach(function(mc,k){var d=Math.abs(mc-wc);if(d<dist){dist=d;nearest=k}});
            var gap=monthCenters.length>1?median(monthCenters.slice(1).map(function(x,k){return x-monthCenters[k]})):40;
            if(dist<=Math.max(18,gap*.48))idx=[nearest];
          }
          if(!idx.length)return;
          var vals=splitMergedDigitsForCount(raw,idx.length);if(!vals||vals.length!==idx.length)return;
          idx.forEach(function(k,n){assigned[k]=vals[n];confs.push(Number(w.conf)||0)});
        });
        if(assigned.filter(function(v){return Number.isFinite(v)}).length<12)continue;
        var useValues=assigned.slice(-12),useMonths=cols.months.slice(-12);
        if(useValues.some(function(v){return !Number.isFinite(v)||v<50||v>15000})||!consecutive(useMonths))continue;
        var annual=useValues.reduce(function(a,b){return a+b},0);if(annual<1200||annual>150000)continue;
        var confidence=Math.max(50,median(confs)),score=30+(assigned.length>=13&&Number.isFinite(assigned[0])?3:0)+(confidence>=65?3:1);
        if(!best||score>best.score)best={score:score,values:useValues,annual:annual,confidence:confidence,months:useMonths};
      }
    }
    return best;
  }

  function parseComEdLineHistory(words){
    var groups=lineGroups(words),monthRe=/\b(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\b/g,best=null;
    for(var i=0;i<groups.length;i++){
      var months=String(groups[i].text||'').toUpperCase().match(monthRe)||[];
      if(months.length<12)continue;
      var trailingMonths=months.slice(-12);if(!consecutive(trailingMonths))continue;
      for(var back=1;back<=5;back++){
        if(i-back<0)continue;
        var values=(String(groups[i-back].text||'').match(/\b\d{1,5}\b/g)||[]).map(Number).filter(function(n){return Number.isFinite(n)&&n>=0&&n<=15000});
        if(values.length<12)continue;
        var trailingValues=values.slice(-12),annual=trailingValues.reduce(function(a,b){return a+b},0);
        if(annual<1200||annual>150000)continue;
        var confidence=median(groups[i].words.concat(groups[i-back].words).map(function(w){return Number(w.conf)}).filter(Number.isFinite));
        var score=20+(months.length>=13?2:0)+(values.length>=13?2:0)+(confidence>=65?3:confidence>=45?2:1);
        if(!best||score>best.score)best={score:score,values:trailingValues,annual:annual,confidence:confidence};
      }
    }
    return best;
  }
  function parseComEdLines(text,words,options){
    options=options||{};
    var raw=String(text||''),utility=String(options.utility||'').toUpperCase();
    var utilityHint=/\bComEd\b/i.test(raw)||utility.indexOf('COMED')>=0;
    var chartHint=/TOTAL\s+USAGE/i.test(raw)||/monthly\s+usage|Electric\s+Usage|kWh/i.test(raw);
    if(!utilityHint||!chartHint)return null;
    var merged=parseComEdMergedBarHistory(words);
    if(merged)return {status:'OK',code:'COMED_IMAGE_OCR_BAR_LABELS_VERIFIED',utility_name:'ComEd',service_zip:serviceZip(raw),monthly_usage_kwh:merged.values,annual_usage_kwh:merged.annual,current_period_kwh:merged.values[11],average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:merged.confidence>=65?'HIGH':'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'COMED_PRINTED_12_MONTH_BAR_LABELS',page_count:1};
    var line=parseComEdLineHistory(words);
    if(line)return {status:'OK',code:'COMED_IMAGE_OCR_LINE_HISTORY_VERIFIED',utility_name:'ComEd',service_zip:serviceZip(raw),monthly_usage_kwh:line.values,annual_usage_kwh:line.annual,current_period_kwh:line.values[11],average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:line.confidence>=65?'HIGH':'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'COMED_IMAGE_OCR_12_MONTH_HISTORY',page_count:1};
    var spatial=spatialMonthlySeries(raw,words,{maxMonthly:15000,maxAnnual:150000});
    if(!spatial){
      var coverage=visibleMonthlyCoverage(words);
      if(coverage>=5&&coverage<12)return {status:'NEEDS_MANUAL_USAGE',code:'COMED_INCOMPLETE_USAGE_HISTORY',utility_name:'ComEd',service_zip:serviceZip(raw),monthly_usage_kwh:null,annual_usage_kwh:null,current_period_kwh:null,average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:'LOW',verification_required:true,auto_use_allowed:false,usage_source:'INCOMPLETE_VISIBLE_MONTHLY_HISTORY',page_count:1};
      return null;
    }
    return {status:'OK',code:'COMED_IMAGE_OCR_SPATIAL_HISTORY_VERIFIED',utility_name:'ComEd',service_zip:serviceZip(raw),monthly_usage_kwh:spatial.values,annual_usage_kwh:spatial.annual,current_period_kwh:spatial.values[11],average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:spatial.confidence>=65?'HIGH':'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'COMED_IMAGE_OCR_12_MONTH_HISTORY',page_count:1};
  }

  async function recognize(canvas,psm){
    var worker=await getWorker();
    try{if(psm!=null)await worker.setParameters({tessedit_pageseg_mode:String(psm)})}catch(_){}
    var result=await worker.recognize(canvas,{}, {tsv:true});
    return {text:result&&result.data&&result.data.text||'',words:parseTsv(result&&result.data&&result.data.tsv||'')};
  }


  function canvasPixelView(canvas){
    var ctx=canvas.getContext('2d',{willReadFrequently:true}),image=ctx.getImageData(0,0,canvas.width,canvas.height);
    return {width:canvas.width,height:canvas.height,data:image.data};
  }
  function pixelGray(view,x,y){
    x=Math.max(0,Math.min(view.width-1,Math.round(x)));y=Math.max(0,Math.min(view.height-1,Math.round(y)));
    var i=(y*view.width+x)*4,d=view.data;return (77*d[i]+150*d[i+1]+29*d[i+2])>>8;
  }
  function detectCwlpGrid(view){
    var W=view.width,H=view.height,x0=Math.round(.56*W),x1=Math.round(.89*W),sampleStep=Math.max(3,Math.round(W/380));
    var yStart=Math.round(.405*H),yEnd=Math.round(.49*H),dMin=Math.max(12,Math.round(.009*H)),dMax=Math.max(dMin+1,Math.round(.016*H));
    var offset=Math.max(3,Math.round(.0024*H)),slopes=[-.03,-.025,-.02,-.015,-.01,-.005,0,.005,.01,.015,.02,.025,.03];
    function lineScore(yBase,slope){
      var sum=0,count=0;
      for(var x=x0;x<=x1;x+=sampleStep){
        var y=Math.round(yBase+slope*(x-x0));if(y-offset<0||y+offset>=H)continue;
        var cur=pixelGray(view,x,y),bg=(pixelGray(view,x,y-offset)+pixelGray(view,x,y+offset))/2,contrast=Math.max(0,bg-cur);
        sum+=Math.min(30,contrast);count++;
      }
      return count?sum/count:0;
    }
    var cache={},best=null;
    slopes.forEach(function(slope){
      var key=String(slope),m={};cache[key]=m;
      for(var y=yStart;y<=Math.round(.60*H);y++)m[y]=lineScore(y,slope);
      for(var spacing=dMin;spacing<=dMax;spacing++){
        for(var top=yStart;top<=yEnd;top++){
          if(top+7*spacing>Math.round(.57*H))continue;
          var vals=[],total=0,min=999;
          for(var k=0;k<8;k++){
            var yy=top+k*spacing,v=0;
            for(var q=-2;q<=2;q++)v=Math.max(v,m[yy+q]||0);
            vals.push(v);total+=v;min=Math.min(min,v);
          }
          var score=total+2*min;
          if(!best||score>best.score)best={score:score,top:top,spacing:spacing,slope:slope,vals:vals,x0:x0,x1:x1};
        }
      }
    });
    if(!best||Math.min.apply(null,best.vals)<1.2||best.score<20)return null;
    /* CWLP_GRID_REFINEMENT_V2: the rough sequence can lock one row above the real 2400-kWh line.
       Choose the offset whose left y-axis has the strongest continuous vertical support. */
    function verticalContinuity(topCandidate,x){
      var bottomCandidate=topCandidate+7*best.spacing,sum=0,count=0,off=Math.max(3,Math.round(W*.003));
      for(var yy=topCandidate;yy<=bottomCandidate;yy+=Math.max(2,Math.round(H/700))){
        var cur=pixelGray(view,x,yy),bg=(pixelGray(view,x-off,yy)+pixelGray(view,x+off,yy))/2;
        sum+=Math.min(30,Math.max(0,bg-cur));count++;
      }
      return count?sum/count:0;
    }
    var refined=null;
    [-1,0,1].forEach(function(shift){
      var candidateTop=best.top+shift*best.spacing;
      if(candidateTop<yStart-best.spacing||candidateTop+7*best.spacing>=H)return;
      for(var xx=Math.round(.50*W);xx<=Math.round(.66*W);xx++){
        var score=verticalContinuity(candidateTop,xx);
        if(!refined||score>refined.score)refined={top:candidateTop,left:xx,score:score};
      }
    });
    if(!refined||refined.score<2)return null;
    /* Fit the eight real row centers instead of retaining the integer rough spacing. */
    var rowCenters=[];
    for(var rk=0;rk<8;rk++){
      var predicted=refined.top+rk*best.spacing,rowBest=null;
      for(var ddy=-5;ddy<=5;ddy++){
        var yy=predicted+ddy,sc=lineScore(yy,best.slope);
        if(!rowBest||sc>rowBest.score)rowBest={y:yy,score:sc};
      }
      rowCenters.push(rowBest.y);
    }
    var nRows=rowCenters.length,sumK=0,sumY=0,sumKK=0,sumKY=0;
    for(var rr=0;rr<nRows;rr++){sumK+=rr;sumY+=rowCenters[rr];sumKK+=rr*rr;sumKY+=rr*rowCenters[rr]}
    var denom=nRows*sumKK-sumK*sumK;
    var refinedSpacing=denom?(nRows*sumKY-sumK*sumY)/denom:best.spacing;
    var topY=(sumY-refinedSpacing*sumK)/nRows;
    if(!Number.isFinite(refinedSpacing)||refinedSpacing<dMin-2||refinedSpacing>dMax+2)return null;
    var bottomY=topY+7*refinedSpacing,ys=[];
    for(var z=0;z<8;z++)ys.push(topY+z*refinedSpacing);
    function verticalScore(x){
      var sum=0,count=0,off=Math.max(3,Math.round(W*.003));
      for(var y=topY;y<=bottomY;y+=Math.max(2,Math.round(H/700))){
        var cur=pixelGray(view,x,y),bg=(pixelGray(view,x-off,y)+pixelGray(view,x+off,y))/2;
        sum+=Math.min(30,Math.max(0,bg-cur));count++;
      }
      return count?sum/count:0;
    }
    var left={x:refined.left,score:refined.score};
    /* Find where the eight horizontal grid rows actually stop. This prevents the legend box
       from being mistaken for the chart's right border. */
    function horizontalSupport(x){
      var sum=0,count=0,off=Math.max(3,Math.round(H*.0018));
      for(var k=0;k<8;k++){
        var yy=Math.round(topY+k*refinedSpacing+best.slope*(x-x0));
        if(yy-off<0||yy+off>=H)continue;
        var cur=pixelGray(view,x,yy),bg=(pixelGray(view,x,yy-off)+pixelGray(view,x,yy+off))/2;
        sum+=Math.max(0,bg-cur);count++;
      }
      return count?sum/count:0;
    }
    var probeStart=Math.round(left.x+.24*W),probeEnd=Math.min(W-1,Math.round(left.x+.48*W)),samples=[];
    for(var px=left.x+12;px<=probeEnd;px++)samples.push(horizontalSupport(px));
    var core=samples.slice(12,Math.min(samples.length,Math.round(.24*W)));
    core.sort(function(a,b){return a-b});var medianSupport=core.length?core[Math.floor(core.length/2)]:0,threshold=Math.max(.65,medianSupport*.20);
    var lastStrong=0,weakRun=0;
    for(var px2=left.x+12;px2<=probeEnd;px2++){
      var local=0,n=0;for(var q=-4;q<=4;q++){local+=horizontalSupport(Math.max(0,Math.min(W-1,px2+q)));n++}
      local/=n;
      if(local>=threshold){lastStrong=px2;weakRun=0}else if(lastStrong){weakRun++;if(weakRun>12&&px2>probeStart)break}
    }
    var right={x:lastStrong,score:lastStrong?horizontalSupport(lastStrong):0};
    if(!right.x||right.x-left.x<.24*W||right.x-left.x>.42*W)return null;
    return {top:topY,bottom:bottomY,spacing:refinedSpacing,slope:best.slope,lineX0:x0,left:left.x,right:right.x,gridRows:ys,score:best.score};
  }

  function adaptiveGraphCrop(canvas,grid){
    var plotW=grid.right-grid.left,plotH=grid.bottom-grid.top;
    var sx=Math.max(0,Math.round(grid.left-.18*plotW)),sy=Math.max(0,Math.round(grid.top-.18*plotH));
    var ex=Math.min(canvas.width,Math.round(grid.right+.30*plotW)),ey=Math.min(canvas.height,Math.round(grid.bottom+.32*plotH));
    var sw=Math.max(1,ex-sx),sh=Math.max(1,ey-sy),scale=2;
    var raw=document.createElement('canvas');raw.width=sw*scale;raw.height=sh*scale;
    var rctx=raw.getContext('2d',{willReadFrequently:true});rctx.drawImage(canvas,sx,sy,sw,sh,0,0,raw.width,raw.height);
    var im=rctx.getImageData(0,0,raw.width,raw.height),W=raw.width,H=raw.height,g=new Uint8Array(W*H),integral=new Float64Array((W+1)*(H+1));
    for(var y=0;y<H;y++){
      var rowSum=0;
      for(var x=0;x<W;x++){
        var i=(y*W+x)*4,gray=(77*im.data[i]+150*im.data[i+1]+29*im.data[i+2])>>8;g[y*W+x]=gray;rowSum+=gray;
        integral[(y+1)*(W+1)+(x+1)]=integral[y*(W+1)+(x+1)]+rowSum;
      }
    }
    var out=document.createElement('canvas');out.width=W;out.height=H;var octx=out.getContext('2d'),odata=octx.createImageData(W,H),rad=Math.max(10,Math.round(Math.min(W,H)*.025)),C=9;
    function rect(x1,y1,x2,y2){
      x1=Math.max(0,x1);y1=Math.max(0,y1);x2=Math.min(W-1,x2);y2=Math.min(H-1,y2);
      var A=y1*(W+1)+x1,B=y1*(W+1)+(x2+1),D=(y2+1)*(W+1)+x1,E=(y2+1)*(W+1)+(x2+1);
      return {sum:integral[E]-integral[B]-integral[D]+integral[A],area:(x2-x1+1)*(y2-y1+1)};
    }
    for(var yy=0;yy<H;yy++)for(var xx=0;xx<W;xx++){
      var box=rect(xx-rad,yy-rad,xx+rad,yy+rad),mean=box.sum/box.area,v=g[yy*W+xx]<mean-C?0:255,j=(yy*W+xx)*4;
      odata.data[j]=odata.data[j+1]=odata.data[j+2]=v;odata.data[j+3]=255;
    }
    octx.putImageData(odata,0,0);
    return {canvas:out,originX:sx,originY:sy,scale:scale};
  }

  async function calibrateCwlpAxis(canvas,grid,contextText){
    var T=await loadScript(),plotW=grid.right-grid.left;

    function parseAxisWord(w,sourceX,sourceY){
      var token=String(w.text||'').toUpperCase().replace(/,/g,'').replace(/[OQ]/g,'0');
      if(/^B00$/.test(token))token='800';
      token=token.replace(/[^\d-]/g,'');
      if(!/^-?\d{1,4}$/.test(token))return null;
      var value=Number(token);if(!Number.isFinite(value)||value<-5000||value>10000)return null;
      if(Math.abs(value)>=100){var snapped=Math.round(value/50)*50;if(Math.abs(snapped-value)<=12)value=snapped}
      if(sourceX>grid.left+.08*plotW||sourceY<grid.top-grid.spacing||sourceY>grid.bottom+grid.spacing)return null;
      var gridTopAtX=grid.top+grid.slope*(sourceX-grid.lineX0),idx=Math.round((sourceY-gridTopAtX)/grid.spacing);
      if(idx<0||idx>7||Math.abs(sourceY-(gridTopAtX+idx*grid.spacing))>.72*grid.spacing)return null;
      return {idx:idx,value:value,conf:Number(w.conf)||0};
    }

    function fitAxis(labels){
      var byIndex={};labels.forEach(function(l){if(!byIndex[l.idx]||l.conf>byIndex[l.idx].conf)byIndex[l.idx]=l});
      labels=Object.keys(byIndex).map(function(k){return byIndex[k]});
      if(labels.length<4)return null;
      var bottomObserved=labels.filter(function(l){return l.idx===7})[0]||null;
      var topObserved=labels.some(function(l){return l.idx<=1});
      if(!bottomObserved||!topObserved)return null;
      var steps=[];
      for(var i=0;i<labels.length;i++)for(var j=i+1;j<labels.length;j++){
        var di=labels[j].idx-labels[i].idx;if(!di)continue;
        var step=(labels[i].value-labels[j].value)/di;
        if(step>=50&&step<=2000)steps.push(step);
      }
      if(!steps.length)return null;
      var step=Math.round(median(steps)/50)*50;
      if(step<50||step>2000)return null;
      var tops=labels.map(function(l){return l.value+l.idx*step}),topValue=Math.round(median(tops)/50)*50;
      var good=labels.filter(function(l){return Math.abs((topValue-l.idx*step)-l.value)<=Math.max(75,step*.22)});
      if(good.length<4)return null;
      var goodBottom=good.filter(function(l){return l.idx===7})[0]||null;
      var goodTop=good.some(function(l){return l.idx<=1});
      if(!goodBottom||!goodTop)return null;
      if(good.length<labels.length){
        topValue=Math.round(median(good.map(function(l){return l.value+l.idx*step}))/50)*50;
      }
      var residualOk=good.every(function(l){return Math.abs((topValue-l.idx*step)-l.value)<=Math.max(75,step*.22)});
      var modeledBottom=topValue-7*step,bottomTolerance=Math.max(75,step*.22);
      if(!residualOk||!goodBottom||Math.abs(modeledBottom-goodBottom.value)>bottomTolerance||topValue<step||topValue>12000)return null;
      return {topValue:topValue,step:step,labels:good,bottomValue:goodBottom.value};
    }

    var prep=adaptiveGraphCrop(canvas,grid),ocr=await recognize(prep.canvas,T.PSM&&T.PSM.SINGLE_BLOCK!=null?T.PSM.SINGLE_BLOCK:6),labels=[];
    ocr.words.forEach(function(w){
      var sourceX=prep.originX+(w.left+w.width/2)/prep.scale,sourceY=prep.originY+(w.top+w.height/2)/prep.scale;
      var parsed=parseAxisWord(w,sourceX,sourceY);if(parsed)labels.push(parsed);
    });
    var fitted=fitAxis(labels);
    if(fitted)return {topValue:fitted.topValue,step:fitted.step,ocrText:ocr.text,labels:fitted.labels,axisSource:'ADAPTIVE_GRAPH_OCR'};

    /* Dedicated y-axis recovery: crop only the numeric scale at 4x.
       CWLP bills use different scales, so never invent a fixed 2400/400 axis. */
    var sx=Math.max(0,Math.round(grid.left-.16*plotW)),ex=Math.min(canvas.width,Math.round(grid.left+.02*plotW));
    var sy=Math.max(0,Math.round(grid.top-.60*grid.spacing)),ey=Math.min(canvas.height,Math.round(grid.bottom+.60*grid.spacing));
    var sw=Math.max(1,ex-sx),sh=Math.max(1,ey-sy),scale=4,axisCanvas=document.createElement('canvas');
    axisCanvas.width=sw*scale;axisCanvas.height=sh*scale;
    var actx=axisCanvas.getContext('2d',{willReadFrequently:true});actx.fillStyle='#fff';actx.fillRect(0,0,axisCanvas.width,axisCanvas.height);
    actx.imageSmoothingEnabled=true;actx.imageSmoothingQuality='high';actx.drawImage(canvas,sx,sy,sw,sh,0,0,axisCanvas.width,axisCanvas.height);
    var axisOcr=await recognize(axisCanvas,T.PSM&&T.PSM.SPARSE_TEXT!=null?T.PSM.SPARSE_TEXT:11),axisLabels=[];
    axisOcr.words.forEach(function(w){
      var sourceX=sx+(w.left+w.width/2)/scale,sourceY=sy+(w.top+w.height/2)/scale;
      var parsed=parseAxisWord(w,sourceX,sourceY);if(parsed)axisLabels.push(parsed);
    });
    fitted=fitAxis(axisLabels);
    if(!fitted)return null;
    return {topValue:fitted.topValue,step:fitted.step,ocrText:String(ocr.text||'')+' '+String(axisOcr.text||''),labels:fitted.labels,axisSource:'DEDICATED_Y_AXIS_OCR'};
  }

  function colorContrastAt(view,x,y){
    var inner=4,outer=10,center={r:0,g:0,b:0,n:0},ring={r:0,g:0,b:0,n:0},W=view.width,H=view.height,d=view.data;
    for(var dy=-outer;dy<=outer;dy++)for(var dx=-outer;dx<=outer;dx++){
      var xx=Math.round(x+dx),yy=Math.round(y+dy);if(xx<0||yy<0||xx>=W||yy>=H)continue;
      var i=(yy*W+xx)*4,target=Math.abs(dx)<=inner&&Math.abs(dy)<=inner?center:ring;
      target.r+=d[i];target.g+=d[i+1];target.b+=d[i+2];target.n++;
    }
    if(!center.n||!ring.n)return {warm:0,green:0,dark:0};
    ['r','g','b'].forEach(function(k){center[k]/=center.n;ring[k]/=ring.n});
    var centerLum=(center.r+center.g+center.b)/3,ringLum=(ring.r+ring.g+ring.b)/3;
    var warm=(center.r-center.g)-(ring.r-ring.g)+.3*((center.r-center.b)-(ring.r-ring.b));
    var green=(center.g-center.r)-(ring.g-ring.r)+.3*((center.g-center.b)-(ring.g-ring.b));
    return {warm:warm,green:green,dark:ringLum-centerLum};
  }

  function graphMonthCandidates(view,grid,monthIndex){
    var center=grid.left+(monthIndex+.5)*(grid.right-grid.left)/12,dx=Math.max(4,Math.round(view.width*.0046)),start=Math.round(grid.top+.18*grid.spacing),end=Math.round(grid.bottom-.12*grid.spacing),raw=[];
    for(var x=Math.round(center-dx);x<=Math.round(center+dx);x++){
      for(var y=start;y<=end;y++){
        var f=colorContrastAt(view,x,y);
        if(f.dark<3&&Math.max(Math.abs(f.warm),Math.abs(f.green))<5)continue;
        var prev=2*Math.max(0,f.warm)+.2*Math.max(0,f.dark)-3*Math.max(0,f.green);
        var curr=2*Math.max(0,f.green)+.2*Math.max(0,f.dark)-1.5*Math.max(0,f.warm);
        raw.push({x:x,y:y,warm:f.warm,green:f.green,dark:f.dark,previousScore:prev,currentScore:curr});
      }
    }
    function distinct(field){
      var sorted=raw.slice().sort(function(a,b){return b[field]-a[field]}),out=[],sep=Math.max(5,Math.round(grid.spacing*.30));
      sorted.forEach(function(c){if(out.length>=8)return;if(out.every(function(o){return Math.abs(o.y-c.y)>sep}))out.push(c)});
      return out;
    }
    return {center:center,previous:distinct('previousScore'),current:distinct('currentScore'),dark:raw.slice().sort(function(a,b){return b.dark-a.dark}).slice(0,60)};
  }

  function chooseCwlpTrailing12(view,grid,axis,expectedCurrentCount){
    var month=[];for(var m=0;m<12;m++)month.push(graphMonthCandidates(view,grid,m));
    var currentThreshold=100,currentY=[],currentCount=0,expected=Number(expectedCurrentCount||0);

    /* Detect the actual consecutive current-year (green) markers first.
       Billing month is only a sanity check because early-month bills can end on the prior month. */
    for(var j=0;j<12;j++){
      var current=month[j].current[0];
      if(!current||current.currentScore<currentThreshold)break;
      currentY.push(current);currentCount++;
    }
    if(currentCount<1||currentCount>12)return null;
    if(Number.isInteger(expected)&&expected>=1&&expected<=12){
      var priorMonth=Math.max(1,expected-1);
      if(currentCount!==expected&&currentCount!==priorMonth)return null;
    }

    var previous=[],minPreviousScore=999;
    for(var mi=currentCount;mi<12;mi++){
      var candidate=month[mi].previous[0];
      if(!candidate)return null;
      previous.push(candidate);minPreviousScore=Math.min(minPreviousScore,candidate.previousScore);
    }
    var selected=[],p=0;
    for(var k=0;k<12;k++)selected.push(k<currentCount?currentY[k]:previous[p++]);
    var values=selected.map(function(c,index){
      var x=grid.left+(index+.5)*(grid.right-grid.left)/12,topAtX=grid.top+grid.slope*(x-grid.lineX0);
      var raw=axis.topValue-(((c.y+.5)-topAtX)/grid.spacing)*axis.step;
      return Math.round(raw/50)*50;
    });
    if(values.some(function(v){return !Number.isFinite(v)||v<0||v>8000}))return null;
    var annual=values.reduce(function(a,b){return a+b},0);if(annual<1200||annual>60000)return null;
    return {values:values,annual:annual,currentMonthCount:currentCount,minPreviousScore:minPreviousScore,billingMonthGuided:Number.isInteger(expected)&&(currentCount===expected||currentCount===Math.max(1,expected-1))};
  }

  function cwlpOcrAnchoredGrid(words,canvas){
    words=Array.isArray(words)?words:[];if(words.length<20)return null;
    var W=canvas.width,H=canvas.height,groups=lineGroups(words),title=null;
    groups.forEach(function(g){
      var t=String(g.text||'');
      if(/Electric/i.test(t)&&(/Usage/i.test(t)||/36\s*month/i.test(t))){
        if(!title||g.top>title.top)title=g;
      }
    });
    var titleBottom=0;
    if(title&&title.words&&title.words.length)titleBottom=Math.max.apply(null,title.words.map(function(w){return w.top+w.height}));

    var monthRows=[],monthWords=words.filter(function(w){return !!monthToken(w.text)&&Number(w.conf)>=20});
    var mh=Math.max(6,median(monthWords.map(function(w){return Math.max(1,w.height)})));
    monthWords.forEach(function(w){
      if(titleBottom&&w.top<titleBottom-4)return;
      var row=null;
      for(var i=0;i<monthRows.length;i++){
        if(Math.abs(w.top-monthRows[i].top)<=Math.max(10,mh*1.8)){row=monthRows[i];break}
      }
      if(!row){row={top:w.top,words:[]};monthRows.push(row)}
      row.words.push(w);row.top=median(row.words.map(function(x){return x.top}));
    });
    var candidates=[];
    monthRows.forEach(function(row){
      var bestByMonth={};
      row.words.forEach(function(w){var mon=monthToken(w.text);if(!mon)return;if(!bestByMonth[mon]||w.conf>bestByMonth[mon].conf)bestByMonth[mon]=w});
      var ms=Object.keys(bestByMonth),count=ms.length;if(count<9)return;
      var distance=titleBottom?Math.max(0,row.top-titleBottom):0;
      if(titleBottom&&(row.top<titleBottom||distance>.28*H))return;
      candidates.push({row:row,bestByMonth:bestByMonth,count:count,score:count*100-(titleBottom?distance:0)+(titleBottom?0:row.top/H*10)});
    });
    if(!candidates.length)return null;
    candidates.sort(function(a,b){return b.score-a.score});var chosen=candidates[0];

    var pts=[];
    Object.keys(chosen.bestByMonth).forEach(function(mon){
      var w=chosen.bestByMonth[mon],idx=MONTHS.indexOf(mon);
      if(idx>=0)pts.push({idx:idx,x:w.left+w.width/2,w:w});
    });
    if(pts.length<9)return null;
    var n=pts.length,sumI=0,sumX=0,sumII=0,sumIX=0;
    pts.forEach(function(p){sumI+=p.idx;sumX+=p.x;sumII+=p.idx*p.idx;sumIX+=p.idx*p.x});
    var denom=n*sumII-sumI*sumI;if(!denom)return null;
    var gap=(n*sumIX-sumI*sumX)/denom,intercept=(sumX-gap*sumI)/n;
    if(!Number.isFinite(gap)||gap<5||gap>.15*W)return null;
    var residuals=pts.map(function(p){return Math.abs(p.x-(intercept+gap*p.idx))});
    if(median(residuals)>Math.max(4,gap*.30))return null;
    var left=intercept-gap/2,right=intercept+11*gap+gap/2,monthTop=chosen.row.top;
    if(left<0||right>W||right-left<.15*W||right-left>.80*W)return null;

    function axisValue(word){
      var token=String(word.text||'').toUpperCase().replace(/,/g,'').replace(/[OQ]/g,'0').replace(/[^\d-]/g,'');
      if(!/^\d{1,4}$/.test(token))return null;
      var value=Number(token);if(!Number.isFinite(value)||value<0||value>6000)return null;
      if(value>=100){var snapped=Math.round(value/50)*50;if(Math.abs(snapped-value)<=15)value=snapped}
      return value;
    }
    var yMin=titleBottom?titleBottom-5:Math.max(0,monthTop-.28*H),yMax=monthTop-mh*.45;
    var labelLeft=Math.max(0,left-Math.max(.20*W,gap*6)),labelRight=left-gap*.10,labels=[];
    words.forEach(function(w){
      if(Number(w.conf)<18)return;
      var value=axisValue(w);if(value==null)return;
      var cx=w.left+w.width/2,cy=w.top+w.height/2;
      if(cx<labelLeft||cx>labelRight||cy<yMin||cy>yMax)return;
      labels.push({value:value,x:cx,y:cy,conf:Number(w.conf)||0});
    });
    if(labels.length<4)return null;

    var best=null;
    for(var i=0;i<labels.length;i++)for(var j=i+1;j<labels.length;j++){
      var a=labels[i],b=labels[j],dy=b.y-a.y;if(Math.abs(dy)<6)continue;
      var slope=(b.value-a.value)/dy;if(!Number.isFinite(slope)||slope>=-1||slope<-100)continue;
      var interceptV=a.value-slope*a.y,tol=Math.max(55,Math.abs(slope)*mh*.85),inliers=[];
      labels.forEach(function(l){if(Math.abs((interceptV+slope*l.y)-l.value)<=tol)inliers.push(l)});
      if(inliers.length<4)continue;
      var err=inliers.reduce(function(s,l){return s+Math.abs((interceptV+slope*l.y)-l.value)},0)/inliers.length;
      var score=inliers.length*100-err;
      if(!best||score>best.score)best={score:score,inliers:inliers};
    }
    if(!best||best.inliers.length<4)return null;

    var ys=best.inliers,nn=ys.length,sumY=0,sumV=0,sumYY=0,sumYV=0;
    ys.forEach(function(l){sumY+=l.y;sumV+=l.value;sumYY+=l.y*l.y;sumYV+=l.y*l.value});
    var den=nn*sumYY-sumY*sumY;if(!den)return null;
    var slopeV=(nn*sumYV-sumY*sumV)/den,interV=(sumV-slopeV*sumY)/nn;
    if(!Number.isFinite(slopeV)||slopeV>=-1||slopeV<-100)return null;

    var ordered=ys.slice().sort(function(a,b){return a.y-b.y}),diffs=[];
    for(var d=1;d<ordered.length;d++){var dv=Math.abs(ordered[d-1].value-ordered[d].value);if(dv>=50&&dv<=2000)diffs.push(dv)}
    if(!diffs.length)return null;
    var step=Math.round(median(diffs)/50)*50;if(step<50||step>2000)return null;
    var topValue=Math.max.apply(null,ys.map(function(l){return l.value})),topY=(topValue-interV)/slopeV,spacing=step/(-slopeV);
    if(!Number.isFinite(topY)||!Number.isFinite(spacing)||spacing<3||spacing>.15*H)return null;
    var zeroY=(0-interV)/slopeV,bottomY=zeroY;
    if(!Number.isFinite(bottomY)||bottomY<=topY||bottomY>monthTop+mh*1.7){
      var lowValue=Math.min.apply(null,ys.map(function(l){return l.value}));bottomY=(lowValue-interV)/slopeV;
    }
    if(bottomY<=topY||bottomY>monthTop+mh*1.7)return null;
    return {
      grid:{top:topY,bottom:bottomY,spacing:spacing,slope:0,lineX0:left,left:left,right:right,gridRows:[],score:best.score},
      axis:{topValue:topValue,step:step,labels:ys,axisSource:'CWLP_OCR_ANCHORED_AXIS'},
      monthCount:pts.length
    };
  }

  function chooseCwlpAnchoredTrailing12(view,grid,axis,expectedCurrentCount){
    var month=[];for(var m=0;m<12;m++)month.push(graphMonthCandidates(view,grid,m));
    var currentThreshold=100,currentY=[],currentCount=0,expected=Number(expectedCurrentCount||0);
    for(var j=0;j<12;j++){
      var list=month[j].current,current=list[0],second=list[1];
      if(!current||current.currentScore<currentThreshold)break;
      if(second&&current.currentScore-second.currentScore<Math.max(8,current.currentScore*.08))return null;
      currentY.push(current);currentCount++;
    }
    if(currentCount<1||currentCount>12)return null;
    if(Number.isInteger(expected)&&expected>=1&&expected<=12){
      var priorMonth=Math.max(1,expected-1);if(currentCount!==expected&&currentCount!==priorMonth)return null;
    }
    var previous=[],minPreviousScore=999,minMargin=999;
    for(var mi=currentCount;mi<12;mi++){
      var prevList=month[mi].previous,candidate=prevList[0],runner=prevList[1];
      if(!candidate||candidate.previousScore<10)return null;
      var margin=runner?candidate.previousScore-runner.previousScore:candidate.previousScore;
      if(margin<Math.max(2.5,candidate.previousScore*.08))return null;
      previous.push(candidate);minPreviousScore=Math.min(minPreviousScore,candidate.previousScore);minMargin=Math.min(minMargin,margin);
    }
    var selected=[],p=0;for(var k=0;k<12;k++)selected.push(k<currentCount?currentY[k]:previous[p++]);
    var values=selected.map(function(c,index){
      var x=grid.left+(index+.5)*(grid.right-grid.left)/12,topAtX=grid.top+grid.slope*(x-grid.lineX0);
      var raw=axis.topValue-(((c.y+.5)-topAtX)/grid.spacing)*axis.step;return Math.round(raw/50)*50;
    });
    if(values.some(function(v){return !Number.isFinite(v)||v<0||v>8000}))return null;
    var annual=values.reduce(function(a,b){return a+b},0);if(annual<1200||annual>60000)return null;
    return {values:values,annual:annual,currentMonthCount:currentCount,minPreviousScore:minPreviousScore,minPreviousMargin:minMargin,billingMonthGuided:Number.isInteger(expected)};
  }

  function upscaleOcrCanvas(canvas,maxSide,documentMode){
    var W=canvas.width,H=canvas.height,target=Math.max(W,H),scale=Math.min(1.8,Number(maxSide||3200)/target);
    if(scale<1.15)scale=1.15;
    var out=document.createElement('canvas');out.width=Math.max(1,Math.round(W*scale));out.height=Math.max(1,Math.round(H*scale));
    var ctx=out.getContext('2d',{willReadFrequently:true});ctx.fillStyle='#fff';ctx.fillRect(0,0,out.width,out.height);
    ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';ctx.drawImage(canvas,0,0,out.width,out.height);
    if(documentMode){
      var im=ctx.getImageData(0,0,out.width,out.height),d=im.data;
      for(var i=0;i<d.length;i+=4){
        var g=(77*d[i]+150*d[i+1]+29*d[i+2])>>8,v=Math.max(0,Math.min(255,(g-128)*1.38+138));
        d[i]=d[i+1]=d[i+2]=v;
      }
      ctx.putImageData(im,0,0);
    }
    return out;
  }

  function parseAmerenBarHistory(canvas,ocr,options){
    options=options||{};var raw=String(ocr&&ocr.text||''),words=Array.isArray(ocr&&ocr.words)?ocr.words:[],utility=String(options.utility||'').toUpperCase();
    if(utility.indexOf('AMEREN')<0&&!/AMEREN/i.test(raw))return null;
    var monthWords=words.filter(function(w){return !!monthToken(w.text)&&Number(w.conf)>=15});
    if(monthWords.length<12)return null;
    var mh=Math.max(6,median(monthWords.map(function(w){return Math.max(1,w.height)}))),rows=[];
    monthWords.slice().sort(function(a,b){return a.top-b.top}).forEach(function(w){
      var row=null;
      for(var i=0;i<rows.length;i++){if(Math.abs(w.top-rows[i].top)<=Math.max(10,mh*1.6)){row=rows[i];break}}
      if(!row){row={top:w.top,words:[]};rows.push(row)}
      row.words.push(w);row.top=median(row.words.map(function(x){return x.top}));
    });
    var groups=lineGroups(words),electricHints=groups.filter(function(g){return /Electric/i.test(g.text)&&/(Usage|kWh|Kilowatt)/i.test(g.text)}),gasHints=groups.filter(function(g){return /Gas/i.test(g.text)&&/(Usage|Therm)/i.test(g.text)});
    var candidates=[];
    rows.forEach(function(row){
      var sorted=row.words.slice().sort(function(a,b){return a.left-b.left}),bestWindow=null;
      [13,12].some(function(len){
        for(var s=0;s+len<=sorted.length;s++){
          var slice=sorted.slice(s,s+len),ms=slice.map(function(w){return monthToken(w.text)});
          if(!consecutive(ms))continue;
          var centers=slice.map(function(w){return w.left+w.width/2}),gaps=[];
          for(var g=1;g<centers.length;g++)gaps.push(centers[g]-centers[g-1]);
          var gap=median(gaps);if(gap<5)return;
          var regular=gaps.filter(function(x){return Math.abs(x-gap)<=Math.max(6,gap*.28)}).length;
          if(regular<gaps.length-2)return;
          bestWindow={words:slice,months:ms,centers:centers,gap:gap};break;
        }
        return !!bestWindow;
      });
      if(!bestWindow)return;
      var priorElectric=electricHints.filter(function(g){return g.top<row.top&&row.top-g.top<Math.max(140,mh*12)}).sort(function(a,b){return b.top-a.top})[0]||null;
      var priorGas=gasHints.filter(function(g){return g.top<row.top&&row.top-g.top<Math.max(140,mh*12)}).sort(function(a,b){return b.top-a.top})[0]||null;
      var score=bestWindow.words.length*100-row.top*.001;
      if(priorElectric)score+=300-Math.min(250,row.top-priorElectric.top);
      if(priorGas&&(!priorElectric||priorGas.top>priorElectric.top))score-=500;
      candidates.push({row:row,window:bestWindow,score:score});
    });
    if(!candidates.length)return null;
    candidates.sort(function(a,b){return b.score-a.score});
    var chosen=candidates[0],monthTop=chosen.row.top,centers=chosen.window.centers,gap=chosen.window.gap,months=chosen.window.months;
    if(centers.length<12)return null;

    var numeric=words.filter(function(w){
      if(Number(w.conf)<10)return false;var n=numberToken(w.text);if(n==null||n<40||n>15000)return false;
      return w.top<monthTop-mh*.35&&monthTop-w.top<Math.max(140,mh*7);
    });
    var numberRows=[];
    numeric.slice().sort(function(a,b){return a.top-b.top}).forEach(function(w){
      var row=null;
      for(var i=0;i<numberRows.length;i++){if(Math.abs(w.top-numberRows[i].top)<=Math.max(8,mh*.8)){row=numberRows[i];break}}
      if(!row){row={top:w.top,words:[]};numberRows.push(row)}
      row.words.push(w);row.top=median(row.words.map(function(x){return x.top}));
    });
    numberRows=numberRows.filter(function(row){
      if(row.words.length<5)return false;
      var matched=0;centers.forEach(function(cx){if(row.words.some(function(w){return Math.abs((w.left+w.width/2)-cx)<=Math.max(18,gap*.45)}))matched++});
      row.matched=matched;return matched>=5;
    }).sort(function(a,b){
      var as=a.matched*100-Math.abs(monthTop-a.top-mh*2.5),bs=b.matched*100-Math.abs(monthTop-b.top-mh*2.5);return bs-as;
    });
    if(!numberRows.length)return null;
    var numberRow=numberRows[0],numberTop=numberRow.top;

    var valueByIndex={};
    centers.forEach(function(cx,index){
      var nearby=numberRow.words.filter(function(w){return Math.abs((w.left+w.width/2)-cx)<=Math.max(18,gap*.45)})
        .sort(function(a,b){return Math.abs((a.left+a.width/2)-cx)-Math.abs((b.left+b.width/2)-cx)});
      if(!nearby.length)return;
      var value=numberToken(nearby[0].text);if(value!=null)valueByIndex[index]={value:value,conf:nearby[0].conf};
    });

    var view=canvasPixelView(canvas),W=view.width,H=view.height,d=view.data;
    function blueAt(x,y){
      x=Math.max(0,Math.min(W-1,Math.round(x)));y=Math.max(0,Math.min(H-1,Math.round(y)));
      var i=(y*W+x)*4,r=d[i],g=d[i+1],b=d[i+2];
      return b>105&&(b-r)>22&&(g-r)>8;
    }
    var yStart=Math.max(0,Math.round(monthTop-Math.max(220,mh*11))),yEnd=Math.min(H-1,Math.round(numberTop-2)),bars=[];
    centers.forEach(function(cx){
      var half=Math.max(2,Math.min(8,Math.round(gap*.10))),runs=[],start=null,last=null;
      for(var y=yStart;y<=yEnd;y++){
        var hits=0,total=0;
        for(var dx=-half;dx<=half;dx++){total++;if(blueAt(cx+dx,y))hits++}
        var on=hits>=Math.max(2,Math.ceil(total*.18));
        if(on){if(start==null)start=y;last=y}
        else if(start!=null){if(last-start+1>=Math.max(3,Math.round(mh*.12)))runs.push({top:start,bottom:last,height:last-start+1});start=last=null}
      }
      if(start!=null&&last-start+1>=Math.max(3,Math.round(mh*.12)))runs.push({top:start,bottom:last,height:last-start+1});
      runs.sort(function(a,b){return b.bottom-a.bottom||b.height-a.height});
      bars.push(runs[0]||null);
    });
    if(bars.filter(Boolean).length<centers.length)return null;
    var bottoms=bars.map(function(b){return b.bottom}),bottomMedian=median(bottoms),bottomTol=Math.max(5,mh*.55);
    if(bottoms.filter(function(v){return Math.abs(v-bottomMedian)<=bottomTol}).length<centers.length-1)return null;

    var pairs=[];
    bars.forEach(function(bar,index){var item=valueByIndex[index];if(item&&bar&&bar.height>0)pairs.push({index:index,h:bar.height,v:item.value,conf:item.conf})});
    if(pairs.length<6)return null;
    var slopes=[];
    for(var i=0;i<pairs.length;i++)for(var j=i+1;j<pairs.length;j++){
      var dh=pairs[j].h-pairs[i].h;if(Math.abs(dh)<Math.max(3,mh*.10))continue;
      var slope=(pairs[j].v-pairs[i].v)/dh;if(slope>2&&slope<100)slopes.push(slope);
    }
    if(slopes.length<4)return null;
    var slope=median(slopes),intercept=median(pairs.map(function(p){return p.v-slope*p.h}));
    var inliers=pairs.filter(function(p){
      var pred=slope*p.h+intercept,tol=Math.max(75,Math.max(p.v,pred)*.13);
      return pred>0&&Math.abs(pred-p.v)<=tol;
    });
    if(inliers.length<6)return null;
    var n=inliers.length,sumH=0,sumV=0,sumHH=0,sumHV=0;
    inliers.forEach(function(p){sumH+=p.h;sumV+=p.v;sumHH+=p.h*p.h;sumHV+=p.h*p.v});
    var den=n*sumHH-sumH*sumH;if(!den)return null;
    slope=(n*sumHV-sumH*sumV)/den;intercept=(sumV-slope*sumH)/n;
    if(!Number.isFinite(slope)||slope<=2||slope>=100||!Number.isFinite(intercept))return null;
    var absErrs=[],relErrs=[];
    inliers.forEach(function(p){var pred=slope*p.h+intercept,err=Math.abs(pred-p.v);absErrs.push(err);relErrs.push(err/Math.max(1,p.v))});
    var medAbs=median(absErrs),medRel=median(relErrs);
    var hRange=Math.max.apply(null,inliers.map(function(p){return p.h}))-Math.min.apply(null,inliers.map(function(p){return p.h}));
    if(medRel>.10||medAbs>70||hRange<Math.max(8,mh*.30))return null;

    var inlierByIndex={};inliers.forEach(function(p){inlierByIndex[p.index]=p});
    var allValues=bars.map(function(bar,index){
      if(inlierByIndex[index])return Math.round(inlierByIndex[index].v);
      var predicted=slope*bar.height+intercept;
      if(!Number.isFinite(predicted)||predicted<40||predicted>15000)return null;
      return Math.round(predicted);
    });
    if(allValues.some(function(v){return v==null}))return null;
    var trailing=allValues.length===13?allValues.slice(1):allValues.slice(-12),trailingMonths=months.length===13?months.slice(1):months.slice(-12);
    if(trailing.length!==12||!consecutive(trailingMonths))return null;
    var annual=trailing.reduce(function(a,b){return a+b},0);if(annual<1200||annual>150000)return null;
    return {
      status:'OK',code:'AMEREN_IMAGE_BAR_HEIGHT_VERIFIED_V253',utility_name:'Ameren Illinois',service_zip:serviceZip(raw),
      monthly_usage_kwh:trailing,annual_usage_kwh:annual,current_period_kwh:trailing[11],average_monthly_bill:null,amount_used_for_estimation:null,
      usage_confidence:'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'AMEREN_IMAGE_BAR_HEIGHT_CALIBRATED_12_MONTH_HISTORY',page_count:1,
      bar_month_count:allValues.length,bar_label_count:pairs.length,bar_label_inliers:inliers.length,bar_fit_median_relative_error:medRel,bar_fit_median_abs_error:medAbs
    };
  }

  async function parseCwlpCanvas(canvas,initialOcr,options){
    options=options||{};var utility=String(options.utility||''),text=String(initialOcr&&initialOcr.text||''),utilityHint=String(utility||'').toUpperCase()==='CWLP';
    var billIdentity=/CWLP|CITY\s+WATER[\s\S]{0,30}LIGHT[\s\S]{0,30}POWER/i.test(text);
    var chartIdentity=/36\s*month/i.test(text)||/Electric\s+Usage/i.test(text);
    if(!utilityHint&&(!billIdentity||!chartIdentity))return null;
    var billingMatch=text.match(/Billing\s*Date\s*:?\s*(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})/i),expectedCurrentCount=billingMatch?Math.max(1,Math.min(12,Number(billingMatch[1]))):0;
    var view=canvasPixelView(canvas),grid=detectCwlpGrid(view);

    if(grid){
      var axis=await calibrateCwlpAxis(canvas,grid,text);
      if(axis){
        var trailing=chooseCwlpTrailing12(view,grid,axis,expectedCurrentCount);
        var combinedText=text+' '+String(axis.ocrText||'');
        if(trailing&&(!utilityHint||/36\s*month/i.test(combinedText)||/Electric\s+Usage/i.test(combinedText))&&axis.labels&&axis.labels.length>=2&&trailing.minPreviousScore>=6.0){
          var zip=serviceZip(text)||serviceZip(combinedText)||null;
          return {status:'OK',code:'CWLP_GRAPH_DYNAMIC_AXIS_VERIFIED_V252',utility_name:'CWLP',service_zip:zip,monthly_usage_kwh:trailing.values.slice(),annual_usage_kwh:trailing.annual,current_period_kwh:null,average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'CWLP_36_MONTH_GRAPH_PIXEL_COLOR_DETERMINISTIC',page_count:1,graph_month_count:12,graph_current_month_count:trailing.currentMonthCount,graph_previous_series_min_score:Number(trailing.minPreviousScore),graph_quality_gate:'PASS'};
        }
      }
    }

    var anchored=cwlpOcrAnchoredGrid(initialOcr&&initialOcr.words||[],canvas);
    if(!anchored)return null;
    var anchoredTrailing=chooseCwlpAnchoredTrailing12(view,anchored.grid,anchored.axis,expectedCurrentCount);
    if(!anchoredTrailing)return null;
    var anchoredZip=serviceZip(text)||null;
    return {status:'OK',code:'CWLP_GRAPH_OCR_ANCHOR_VERIFIED_V253',utility_name:'CWLP',service_zip:anchoredZip,monthly_usage_kwh:anchoredTrailing.values.slice(),annual_usage_kwh:anchoredTrailing.annual,current_period_kwh:null,average_monthly_bill:null,amount_used_for_estimation:null,usage_confidence:'GOOD',verification_required:false,auto_use_allowed:true,usage_source:'CWLP_36_MONTH_GRAPH_OCR_ANCHORED_COLOR',page_count:1,graph_month_count:12,graph_current_month_count:anchoredTrailing.currentMonthCount,graph_previous_series_min_score:Number(anchoredTrailing.minPreviousScore),graph_previous_series_min_margin:Number(anchoredTrailing.minPreviousMargin),graph_axis_label_count:anchored.axis.labels.length,graph_month_label_count:anchored.monthCount,graph_quality_gate:'PASS'};
  }

  async function parseCanvas(canvas,options){
    options=options||{};var T=await loadScript(),selectedUtility=String(options.utility||''),utilityUpper=selectedUtility.toUpperCase();
    var first=await recognize(canvas,T.PSM&&T.PSM.SINGLE_BLOCK!=null?T.PSM.SINGLE_BLOCK:6);
    var explicit=selectedUtility==='CWLP'?null:parseExplicitAnnualKwh(first.text,first.words,selectedUtility);if(explicit)return explicit;
    var ameren=parseAmerenLines(first.text,first.words,options);if(ameren)return ameren;
    var comed=parseComEdLines(first.text,first.words,options);if(comed)return comed;
    var cwlp=await parseCwlpCanvas(canvas,first,options);if(cwlp)return cwlp;

    var second=await recognize(canvas,T.PSM&&T.PSM.SPARSE_TEXT!=null?T.PSM.SPARSE_TEXT:11);
    explicit=selectedUtility==='CWLP'?null:parseExplicitAnnualKwh(second.text,second.words,selectedUtility);if(explicit)return explicit;
    ameren=parseAmerenLines(second.text,second.words,options);if(ameren)return ameren;
    comed=parseComEdLines(second.text,second.words,options);if(comed)return comed;
    cwlp=await parseCwlpCanvas(canvas,second,options);if(cwlp)return cwlp;

    if(utilityUpper.indexOf('AMEREN')>=0){
      var enhancedColor=upscaleOcrCanvas(canvas,3300,false),enhanced=upscaleOcrCanvas(canvas,3300,true),third=await recognize(enhanced,T.PSM&&T.PSM.SPARSE_TEXT!=null?T.PSM.SPARSE_TEXT:11);
      ameren=parseAmerenLines(third.text,third.words,options);
      if(ameren){
        ameren.code='AMEREN_IMAGE_OCR_ENHANCED_HISTORY_VERIFIED';
        ameren.usage_source='AMEREN_ENHANCED_IMAGE_OCR_12_MONTH_HISTORY';
        return ameren;
      }
      ameren=parseAmerenBarHistory(enhancedColor,third,options);if(ameren)return ameren;
    }
    if(utilityUpper==='CWLP'){
      var colorHi=upscaleOcrCanvas(canvas,3200,false),fourth=await recognize(colorHi,T.PSM&&T.PSM.SPARSE_TEXT!=null?T.PSM.SPARSE_TEXT:11);
      cwlp=await parseCwlpCanvas(colorHi,fourth,options);if(cwlp){cwlp.code=cwlp.code==='CWLP_GRAPH_OCR_ANCHOR_VERIFIED_V253'?'CWLP_GRAPH_OCR_ANCHOR_HIRES_VERIFIED_V253':cwlp.code;return cwlp}
    }
    return null;
  }

  async function parse(files,options){
    options=options||{};
    if(!files||!files.length)return null;
    for(var i=0;i<files.length;i++){
      var file=files[i],type=String(file&&file.type||'').toLowerCase(),name=String(file&&file.name||'');
      if(!/^image\/(?:jpeg|png|webp)$/.test(type)&&!(/\.(?:jpe?g|png|webp)$/i.test(name)))continue;
      try{
        var result=await parseCanvas(await imageCanvas(file),options);if(result)return result;
      }catch(err){try{console.warn('LUNOVA_GENERAL_BILL_READER_IMAGE_FALLBACK',String(err&&err.message||err).slice(0,120))}catch(_){}}
    }
    return null;
  }

  window.LuNovaBillReader={parse:parse,parseCanvas:parseCanvas,version:'2.5.2-general-ocr-23-ameren-bar-calibration'};
})();